module.exports = __webpack_public_path__ + "img/75gH6i.jpg";